// extracted by css-extract-rspack-plugin
export default {"header":"GroupPermissions_header__PqoYh","accordion":"GroupPermissions_accordion__BnKS-"};